import { render, staticRenderFns } from "./adminLogin.vue?vue&type=template&id=66ad227a&scoped=true"
import script from "./adminLogin.vue?vue&type=script&lang=js"
export * from "./adminLogin.vue?vue&type=script&lang=js"
import style0 from "./adminLogin.vue?vue&type=style&index=0&id=66ad227a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ad227a",
  null
  
)

export default component.exports